import { getAdminLink, getNormalLink } from '@/components/Apollo/client';
import { useAuthContext } from '@/components/Auth/AuthContext';
import { useUserContext } from '@/components/Auth/UserContext';
import BaseContainer from '@/components/BaseContainer';
import Form from '@/components/Form/Form';
import FormSectionFooter from '@/components/Form/FormSectionFooter';
import TextArea from '@/components/Form/TextArea';
import ScreenMargin from '@/components/ScreenMargin';
import useFormStyle from '@/components/Styles/useFormStyle';
import {
  useGetParametresQuery,
  useListLaboratoiresQuery,
  useUpdateParametresMutation
} from '@/data/data';
import { useApolloClient } from '@apollo/client';
import { Redirect } from 'expo-router';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import { Text } from 'react-native-paper';
import { useToast } from 'react-native-toast-notifications';

const ParametresPage = () => {
  const { data: parameters } = useGetParametresQuery({
    variables: { keyList: ['DISCLAIMER_FR', 'DISCLAIMER_EN', 'INFO_GEN_FR', 'INFO_GEN_EN'] },
    fetchPolicy: 'network-only',
  });
  const { data: laboratoireList, loading: laboratoireListLoading } = useListLaboratoiresQuery();
  const { t } = useTranslation();
  const client = useApolloClient();
  const { user } = useUserContext();
  const authUser = useAuthContext();
  const [loading, setLoading] = useState(false);

  const [updateParameters] = useUpdateParametresMutation();
  const form = useForm();

  const toast = useToast();

  const styles = useFormStyle();

  if (authUser.payload && authUser.payload['cognito:groups'].indexOf('admin') <= -1) {
    return <Redirect href={'/patients'} />;
  }

  return (
    <ScreenMargin>
      <BaseContainer withScrollView={'keyboardAware'}>
        <Text style={styles?.headerForm}>{t('Modifier les paramètres')}</Text>

        <Form
          {...form}
          defaultValues={parameters?.parametres.reduce(
            (acc, cur) => ({ ...acc, [cur.paramKey]: cur.paramValue }),
            {}
          )}
        >
          <View style={styles?.bodyForm}>
            <View style={styles?.groupForm}>
              <Text style={styles?.titleGroupForm}>{t('Données')}</Text>
              <TextArea
                name={'DISCLAIMER_FR'}
                label={t('Disclaimer (FR)')}
                withMargin={false}
                containerStyle={styles.input1Col}
              />
              <TextArea
                name={'DISCLAIMER_EN'}
                label={t('Disclaimer (EN)')}
                withMargin={false}
                containerStyle={styles.input1Col}
              />
              <TextArea
                name={'INFO_GEN_FR'}
                label={t('Informations générales (FR)')}
                withMargin={false}
                containerStyle={styles.input1Col}
              />
              <TextArea
                name={'INFO_GEN_EN'}
                label={t('Informations générales (EN)')}
                withMargin={false}
                containerStyle={styles.input1Col}
              />
            </View>
          </View>
          <View style={styles?.footerForm}>
            <FormSectionFooter
              saveLoading={loading}
              saveDisabled={loading}
              onPress={form.handleSubmit(async (data) => {
                setLoading(true);
                if (user) {
                  client.setLink(getAdminLink());
                  await updateParameters({
                    variables: {
                      objects: Object.entries(data).map(([key, value]) => ({
                        paramKey: key,
                        paramValue: value,
                      })),
                    },
                    fetchPolicy: 'network-only',
                  });
                  client.setLink(getNormalLink());
                  toast.show('Paramètres enregistrés', {
                    type: 'success',
                    placement: 'center',
                    duration: 1000,
                    animationType: 'slide-in',
                    onPress: (id) => {
                      toast.hide(id);
                    },
                  });
                }
                setLoading(false);
              })}
            />
          </View>
        </Form>
      </BaseContainer>
    </ScreenMargin>
  );
};

export default ParametresPage;
